var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 22C17.523 22 22.0001 17.5228 22.0001 12C22.0001 6.47715 17.523 2 12.0001 2C6.47727 2 2.00012 6.47715 2.00012 12C2.00012 17.5228 6.47727 22 12.0001 22ZM16.634 10.3839C17.1222 9.89573 17.1222 9.10427 16.634 8.61612C16.1459 8.12796 15.3544 8.12796 14.8662 8.61612L10.7501 12.7322L9.13401 11.1161C8.64585 10.628 7.85439 10.628 7.36624 11.1161C6.87808 11.6043 6.87808 12.3957 7.36624 12.8839L9.86624 15.3839C10.3544 15.872 11.1459 15.872 11.634 15.3839L16.634 10.3839Z",
    fill: "#399D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publish-icon.b404c81cd3db93b0c2194646cef1d629.svg";
export { ForwardRef as ReactComponent };